import { render, staticRenderFns } from "./LoginAsButton.vue?vue&type=template&id=e523a604&"
import script from "./LoginAsButton.vue?vue&type=script&lang=js&"
export * from "./LoginAsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports